<template>
  <div
    class="login-wrapper"
    :style="{backgroundImage: `url(${banner.bgImg || loginBg})`}"
  >
    <div class="contanier">
      <div class="list">
        <div class="list-item menu-order">
          <img src="@/assets/img/login/icon_order.png" alt="">
          <span>在线下单</span>
        </div>
       <!-- <div class="list-item" @click="$router.push('/seekWarehouses')">
         <img src="@/assets/img/login/icon_house.png" alt="">
         <span>我要寻仓</span>
       </div> -->
      </div>
      <div class="login-content">
        <div class="left">
          <img v-if="!bannerLoading" :src="banner.imgUrl || require('../../assets/img/login/pic_login.png')" alt="" @click="toUrl">
        </div>
        <div class="right">
          <div>
            <div class="flex-a login-title">
              <!-- <img class="login-logo" src="@/assets/img/logo1.png" alt="">
              <h3 class="title">运荔枝货主版</h3> -->
              <img class="login-logo" src="@/assets/img/title.png" />
            </div>
          </div>
          <div class="login-contanier">
            <div v-if="isLogin" class="login">
              <h2 class="login-desc">
                您好，<br />
                欢迎来到运荔枝
              </h2>
              <login-form />
              <div class="to-change">还没有账号？
                <a @click="isLogin = false">申请注册</a>
              </div>
            </div>
            <div v-else class="registery">
              <h2 class="login-desc">
                账号注册
              </h2>
              <registery-form @register="isLogin = true" />
              <div class="to-change">已有账号，去
                <a @click="isLogin = true">登录</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <p class="copyright">版权所有：成都运荔枝科技有限公司    备案号：蜀ICP备19017829号-1</p>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import loginBg from '@/assets/img/login/bg_login_big.png'
import { logout } from "@/services/user";
import { getRosterPage } from './api/auth/index'
import LoginForm from './components/LoginForm.vue'
import RegisteryForm from './components/RegisteryForm.vue'
import env from '../../../env/index';

export default {
  name: 'Login',
  components: {
    LoginForm,
    RegisteryForm
  },
  data() {
    return {
      loginBg,
      account: process.env.VUE_APP_ENV === 'local' ? 13800000001 : '',
      password: process.env.VUE_APP_ENV === 'local' ? 'hope123' : '',
      error: '',
      // registeryForm: this.$form.createForm(this),
      banner: {}, // 配置
      bannerLoading: false,
      isLogin: true, // 是否登录页面
    }
  },
  computed: {
    systemName() {
      return this.$store.state.setting.systemName
    },
  },
  created() {
    if (!window.location.host.includes('localhost')) {
      logout();
      const url = env.NEW_SYSTEM_URL;
      window.location.href = url;
    }
    this.bannerLoading = true
    getRosterPage({
     configKey: 'CONSIGNOR_WEB_Banner',
    }).then((res) => {
      this.bannerLoading = false
      const record  = res[0]?.configValue
      if (record) {
        const info = JSON.parse(record)
        if ((!info.deadline || info.deadline > new Date().getTime())) {
          this.banner = info || {}
        }
      }
    }).catch(() => {
      this.bannerLoading = false
    })
  },
  methods: {
    ...mapMutations('account', ['setUser', 'setPermissions', 'setRoles']),
    toFrogetPassword() {
      this.$router.push('/forgot-password')
    },
    toUrl() {
      const { url } = this.banner
      if (url) {
        window.open(url)
      }
    },
  },
}
</script>

<style lang="less">
.login-submit {
  width: 100%;
  height: 54px;
  padding: 0 7%;
  .login-btn {
    width: 100%;
    height: 100%;
  }
}
.login-content {
  .ant-btn-primary {
    background: linear-gradient(239deg, #06B889 0%, #24D69E 100%);
    box-shadow: 0px 10px 12px 0px rgba(7, 208, 145, 0.5);
    border-radius: 4px;
    color: #fff;
    border: none;
  }
  .ant-btn[disabled], .ant-btn[disabled]:hover .ant-btn[disabled]:focus, .ant-btn[disabled]:active {
    background: linear-gradient(239deg, #06B889 0%, #24D69E 100%);
    box-shadow: none;
    opacity: 0.5;
    color: #fff;
  }
  .ant-input {
    height: 38px;
    padding-right: 0;
  }
  .ant-input-suffix {
    .anticon {
      color: #C9CBCE;
      font-size: 16px;
    }
  }
}
</style>
<style lang="less" scoped>
.login-wrapper {
  width: 100%;
  min-width: 1366px;
  height: 100vh;
  min-height: 768px;
  // background-image: url('../../assets/img/login/bg_login_big.png');
  background-size: 100% 100%;
  // border: 1px solid #979797;
  .contanier {
    width: 75%;
    min-width: 1080px;
    max-width: 1440px;
    margin: 0 auto;
    .list {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 12vh;
      .list-item {
        color: #fff;
        font-size: 24px;
        cursor: pointer;
        position: relative;
        &:hover {
          color: #06B880;
        }
        img {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }
      }
      .menu-order {
        &::after {
          content: '';
          display: inline-block;
          position: absolute;
          bottom: -16px;
          width: 40px;
          left: 50%;
          height: 10px;
          background: #06b880;
          transform: translateX(-50%);
          border-radius: 5px;
        }
      }
      .list-item:last-of-type {
        margin-left: 120px;
      }
    }
    .login-content {
      width: 100%;
      height: 76vh;
      min-height: 580px;
      max-height: 900px;
      background: #FFFFFF;
      border-radius: 16px;
      display: flex;
      .left {
        width: 53%;
        height: 100%;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 16px;
          box-shadow: 2px 0px 12px 0px rgba(135, 160, 164, 0.25);
        }
      }
      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // background-image: url('../../assets/img/login/bg_login.png');
        background-size: 100% 100%;
        > div {
          width: 71%;
          margin: 0 auto;
        }
        .login-title {
          // margin-top: 9%;
        }
        .login-logo {
          width: 150px;
          // height: 45px;
        }
        .title {
          font-size: 24px;
          color: #06B880;
          font-weight: 500;
          height: 24px;
          line-height: 24px;
          padding-left: 8px;
          border-left: 1px solid rgba(23,23,23, 0.3);
          margin-left: 9px;
        }
        .login-contanier {
          margin-top: 4.5%;
          .ant-input {
            height: 40px;
          }
          .login-desc {
            font-weight: bold;
            color: #323232;
            font-size: 30px;
            line-height: 40px;
          }
          .to-change {
            margin-top: 6%;
            text-align: center;
            color: #171717;
            a {
              color: #06B880;
            }
          }
        }
      }
    }
  }
  .copyright {
    font-size: 14px;
    color: #63697A;
    text-align: center;
    margin-top: 7vh;
    // position: absolute;
    // bottom: 20px;
    // left: 50%;
    // transform: translateX(-50%);
  }
}
.flex-a {
  display: flex;
  align-items: center;
}
// .login-wrapper {
//   display: flex;
//   flex-direction: column;
//   height: 100vh;
//   overflow: auto;
//   .copyright {
//     text-align: center;
//     width: 100%;
//     position: absolute;
//     bottom: 20px;
//     font-size: 14px;
//     color: #999999;
//     line-height: 21px;
//   }
//   .login-content-box {
//     width: 100%;
//     height: calc(100vh - 256px);
//     overflow: hidden;
//     margin-top: 128px;
//     position: relative;
//     .login-content {
//       height: calc(100vh - 256px);
//       position: absolute;
//     }
//     @media screen and (min-width: 615px) {
//       .login-content {
//         right: 150px;
//       }
//     }
//   }
//   .login-logo {
//     position: absolute;
//     left: 60px;
//     font-weight: 500;
//     font-size: 32px;
//     letter-spacing: 1px;
//     line-height: 123px;
//     img {
//       width: 65px;
//       height: 65px;
//       margin-right: 13px;
//     }
//     .logo-title {
//       border-left: 1px solid rgba(23,23,23, 0.3);
//       padding-left: 12px;
//       color: #171717;
//       font-weight: 500;
//       font-size: 32px;
//       display: inline-block;
//       height: 32px;
//       line-height: 32px;
//     }
//   }
//   .seekWarehouse-menu {
//     position: absolute;
//     top: 0px;
//     height: 128px;
//     right: 150px;
//     display: flex;
//     width: 500px;
//     justify-content: center;
//     .list-item {
//       padding: 0 55px;
//       flex: 1;
//       &:hover {
//         color: #fff;
//         background-color: #09c077;
//       }
//     }
//     .list {
//       line-height: 128px;
//       cursor: pointer;
//       text-align: center;
//       font-size: 20px;
//       font-weight: bold;
//       background-position: 0px center;
//       background-repeat: no-repeat;
//       background-size: 40px;
//       position: relative;

//       span {
//         margin-left: 40px;
//       }
//       .list-img {
//         width: 40px;
//         height: 40px;
//       }
//     }
//     .menu-order {
//       .list {
//         &::after {
//           content: '';
//           display: inline-block;
//           position: absolute;
//           bottom: 0;
//           height: 6px;
//           width: 100%;
//           left: 50%;
//           height: 6px;
//           background: #06b880;
//           transform: translateX(-50%);
//         }
//         background-image: url('../../assets/img/menu-order.png');
//       }
//       &:hover {
//         .list {
//           background-image: url('../../assets/img/menu-order-hover.png');
//         }
//       }
//     }
//     .menu-warehouse {
//       .list {
//         background-image: url('../../assets/img/menu-house.png');
//       }
//       &:hover {
//         .list {
//           background-image: url('../../assets/img/menu-house-hover.png');
//         }
//       }
//     }
//   }
//   .login-background-image {
//     position: absolute;
//     left: 232px;
//     top: 40px;
//     width: 778px;
//     height: calc(100vh - 256px);
//     img {
//       width: 778px;
//       height: 550px;
//     }
//   }
//   .form-wrapper {
//     background-color: #fff;
//     padding: 60px;
//     padding-top: 50px;
//     border-radius: 8px;
//     position: relative;
//     ::v-deep {
//       .ant-input-prefix {
//         color: #666666;
//         opacity: 0.65;
//       }
//       .ant-input {
//         border: 0;
//         border-bottom: 1px solid #cccccc;
//         border-radius: 0;
//         box-shadow: none;
//         padding-left: 46px;
//       }
//     }
//     .no-account{
//       margin-top: 24px;
//       font-size: 14px;
//     }
//   }
//   .form-header {
//     font-size: 16px;
//     margin-bottom: 60px;
//   }
//   .login-form {
//     width: 380px;
//   }
//   .login-btn {
//     margin-top: 50px;
//     width: 100%;
//   }
//   .forget {
//     width: 100%;
//     text-align: center;
//     color: #06b880;
//     font-size: 14px;
//     text-align: right;
//     margin-top: -14px;
//     &:hover {
//       cursor: pointer;
//     }
//   }
// }
</style>
